// extracted by mini-css-extract-plugin
module.exports = {"shareIcons":"yw6nZ-","shareIconWithName":"yHptu1","icon":"_1vf9cO","iconText":"_3vQq_G"};